/**
 * sectionedChapterAdapter — maps catalog chapters → `UISectionedChapter` for assessment forms.
 */
import { type UISectionedChapter } from "../../../ui/types"

export type ApiCatalogChapter = {
    id?: string | number
    name?: string
    parent_chapter?: { id?: string | number; name?: string } | null
}

export function toUISectionedChapter(raw: ApiCatalogChapter | null | undefined): UISectionedChapter | null {
    if (raw?.id == null || !raw.name) return null
    const parent =
        raw.parent_chapter?.id != null && raw.parent_chapter.name
            ? { id: raw.parent_chapter.id, name: raw.parent_chapter.name }
            : undefined
    return { id: raw.id, name: raw.name, parent }
}

export function toUISectionedChapters(rawList: ApiCatalogChapter[] | null | undefined): UISectionedChapter[] {
    return (rawList ?? [])
        .map((row) => toUISectionedChapter(row))
        .filter((row): row is UISectionedChapter => row != null)
}
